import React, { useState, useEffect, useRef } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import ReactPaginate from "react-paginate";
import Modal from "react-bootstrap/Modal";
import { getSkillByDeptID } from '../HR/Skills/subSkills/api/calls';
import TableLoader from '../../CommanCom/TableLoader';
function EmployeeListCom() {
  let SERVER_URL = process.env.REACT_APP_API_URL;
  let BASE_URL = process.env.REACT_APP_APP_URL;
  let token = JSON.parse(localStorage.getItem('key'));


  const get_oermission_data = useSelector((state) => state);
  const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
  const hr_permission = get_oermission_data.login_Permission.permissions

  const hr_permission_arr = Array()
  if (hr_permission) {
    const hr_permission_arr1 = JSON.parse(hr_permission).split(",")
    hr_permission_arr1.map((item, ind) => {
      hr_permission_arr.push(item);
    })
  }


  const pagination = useRef();
  const [searchemail, setSearchemail] = useState('');
  const [emplist, setEmplist] = useState([]);
  const [perPage, setPerpage] = useState('');
  const [totalitem, setTotalitem] = useState('');
  const [searchbytext, setSearchbytext] = useState('');
  const [dept, setDept] = useState([]);
  const [deptid, setDeptid] = useState('');
  const [skill, setSkill] = useState('');
  const [activeType, setActiveType] = useState('');
  const [skillsList, setSkillsList] = useState([]);
  const [page_Number, setPage_Number] = useState(1);
  const [loadPage,setLoadPage] = useState(true);
  const setPage = ({ selected }) => {
    setLoadPage(true)
    getuserlist(searchbytext, selected + 1, deptid, skill,activeType)
  }
  useEffect(() => {
    setLoadPage(true)
    getuserlist(searchbytext, page_Number, deptid, skill,activeType)
    getDepartment()
    //get_skills_list()
  }, [])
  // const get_skills_list = async () => {
  //   const response = await fetch(SERVER_URL + `api/common/skills_list`,
  //     {
  //       method: 'GET',
  //       headers: {
  //         'Accept': 'application/json',
  //         'Content-Type': 'application/json',
  //         'authorization': `bearer ${token.value}`
  //       },
  //     }).then(res => res.json())
  //     .then(data => {
  //       setSkillsList(data.result)
  //     })
  // }

  const getDepartment = async () => {
    const response = await fetch(SERVER_URL + `api/common/department_list`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      }).then(res => res.json())
      .then(data => {
        setDept(data.result)
      })
  }

  const getuserlist = async (textsearch, pagenumber, dept_id, skill,activeType) => {
    setLoadPage(true)
    const response = await fetch(SERVER_URL + `api/employee?query=${textsearch}&page=${pagenumber == 'undefined' ? 1 : pagenumber}&department=${dept_id}&skill=${skill}&status=${activeType}`,
      {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'authorization': `bearer ${token.value}`
        },
      })
      .then(res => res.json())
      .then(data => {
        setEmplist(data.users)
        setTotalitem(data.Emptotal[0].Total);
        setPerpage(data.limit)
        setLoadPage(false)
      });
  }


  const Search_filter = () => {
    getuserlist(searchbytext, page_Number, deptid, skill,activeType)
  }
  const Reset_filter = () => {
    setSearchbytext('');
    setPage_Number(1);
    setDeptid("");
    setSkill("");
    setActiveType("");
    getuserlist('', 1, '', '','')
  }


  function handleChange(deptid) {
    setDeptid(deptid)
    getSkillByDeptID(deptid).then((res) => {
      if (res.status) {
        setSkillsList(res.data);
      }
    })


    // const response = fetch(SERVER_URL + `api/common/get_department_role`,
    //   {
    //     method: 'PUT',
    //     headers: {
    //       'Accept': 'application/json',
    //       'Content-Type': 'application/json',
    //       'authorization': `bearer ${token.value}`
    //     },
    //     body: JSON.stringify({
    //       id: deptid,
    //     }),
    //   }).then(res => res.json())
    //   .then(data => {
    //     setSkillsList(data.result)
    //   });
  }
  const [userId, setUserId] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [emailcheck, setEmailcheck] = useState(1);
  const [systemcheck, setSystemcheck] = useState(0);

  const itModal = (id) => {
    setShowModal(true);
    setUserId(id)
  }
  const handleClose = () => {
    setUserId('')
    setShowModal(false);
  };
  const handleemail = (e) => {
    setEmailcheck(e.target.value)
  }
  const handlesystem = (e) => {
    setSystemcheck(e.target.value)
  }
  const SaveItRequest = () => {
    sendReqToIT(emailcheck, systemcheck)
  }
  const sendReqToIT = async (emailcheck, systemcheck) => {

    const response = await fetch(SERVER_URL + 'api/employee/hrReqEmail', {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'authorization': `bearer ${token.value}`
      },
      body: JSON.stringify({
        userId: userId,
        emailcheck: emailcheck,
        systemcheck: systemcheck,
      }),
    })
      .then(res => res.json())
      .then(data => {
        // console.log(data)
      });
  }
  return (
    <>

      {showModal ?
        <Modal show={showModal} size="md" id="confirm_login">
          <div className="modal-body">
            <button type="button" onClick={handleClose} className="float-end btn_close" data-bs-dismiss="modal" aria-label="Close">
              <i className="icon icon-cross"></i>
            </button>
            <div className="dash_white_box_ttl text-center" id="requestforemail">Request for Email</div>
            <form>
              <div className="mb-2">

                <div className="form-label">Create Mail</div>
                <div className="form-check d-inline-block hand">
                  <input className="form-check-input" type="radio" name="mailstatus" id="active" onChange={handleemail} value='1' checked={emailcheck == 1} />
                  <label className="form-check-label" for="active">
                    Yes
                  </label>
                </div>
                <div className="form-check d-inline-block hand ml20">
                  <input className="form-check-input" type="radio" name="mailstatus" id="inactive" onChange={handleemail} value='0' checked={emailcheck == 0} />
                  <label className="form-check-label" for="inactive">
                    No
                  </label>
                </div>

              </div>
              <div className="mb-2">
                <div className="form-label">System Require</div>
                <div className="form-check d-inline-block hand">
                  <input className="form-check-input" type="radio" name="systemstatus" id="activesystem" onChange={handlesystem} value='1' checked={systemcheck == 1} />
                  <label className="form-check-label" for="activesystem">
                    Yes
                  </label>
                </div>
                <div className="form-check d-inline-block hand ml20">
                  <input className="form-check-input" type="radio" name="systemstatus" id="inactivesystem" onChange={handlesystem} value='0' checked={systemcheck == 0} />
                  <label className="form-check-label" for="inactivesystem">
                    No
                  </label>
                </div>
              </div>
              <div className="mb-2" style={{ display: `${systemcheck == 1 ? 'block' : 'none'}` }}>
                <label className="col-form-label">System Type</label>
                <select className="form-select">
                  <option>Select system type</option>
                  <option>Desktop</option>
                  <option>Laptop</option>
                </select>
              </div>
            </form>
            <div className="modalfooter">
              <button type="button" onClick={handleClose} className="btn_6 float-end ml10" data-bs-dismiss="modal">Cancel</button>
              <button type="button" className="btn_5 float-end" onClick={SaveItRequest}>Submit</button>
            </div>
          </div>
        </Modal>
        : ''}

      <div className="page-header">
        <h1>
          {
            hr_permission_arr?.includes('26') && (<Link className="btn_5 mr10 float-end" to='/addemployee'>Add Employee</Link>)
          }

          Employee
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li className="current">
            <span>/</span> Employee
          </li>
        </ul>
      </div>
      <div className="row_bg">
        <div className="dash_white_box2 mb20 p20">
          <div className="dash_white_box_ttl">Search</div>
          <div className="row mb10">
            <div className="col-lg-3 col-md-6 pr07">
              <label className="form-label">Employee Name / Code</label>
              <input type="text" className="form-control" onChange={(e) => setSearchbytext(e.target.value)} value={searchbytext} autoComplete='none' placeholder='Search by name' />
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label">Division</label>
              <div className="form-input">
                <select onChange={e => handleChange(e.target.value)} value={deptid} className="form-select">
                  <option value=''>Select Division </option>
                  {
                    dept?.map((item, ind) => {
                      return <option key={ind + 1} value={item.id}>{item.name}</option>
                    })
                  }
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label"> Department</label>
              <div className="form-input">
                <select value={skill} className="form-select" onChange={e => { setSkill(e.target.value) }}>
                  <option value=''>Select Department </option>
                  {
                    skillsList.map((item, ind) => {
                      return <option value={item.id}>{item.name}</option>
                    })
                  }
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pl07 pr07">
              <label className="form-label"> Status</label>
              <div className="form-input">
                <select value={activeType} className="form-select" onChange={e => { setActiveType(e.target.value) }}>
                  <option value=''>Select Status </option>
                       <option value="1">Active</option>
                       <option value="2">Inactive</option>
                   
                </select>
              </div>
            </div>
            <div className="col-lg-3 col-md-6 pr07">
              <label className="d-block mb15"></label>
              <button onClick={Search_filter} className="btn_5 mr08">Search</button>
              <button onClick={Reset_filter} className="btn_6">Reset</button>
            </div>
          </div>
        </div>
        <div className="row mb30">
          <div className="col-md-12">
            <table className="table_style_1">
              <thead>
                <tr>
                  <th>Employee Code</th>
                  <th>Employee Name</th>
                  <th>Division</th>
                  <th>Department </th>
                  <th>Employee Type</th>
                  <th>Status</th>
                  <th style={{ width: "140px" }}>Action</th>
                </tr>
              </thead>
              {
                loadPage === true ? <TableLoader colSpan={7} /> :
              <tbody>

                { emplist?.map((item, ind) => {
                  return <tr key={ind}>
                    <td>{item.user_code ? item.user_code : ''}</td>
                    <td><span className="avatar_icon">{item.name ? item.name.match(/(\b\S)?/g).join("").match(/(^\S|\S$)?/g).join("").toUpperCase() : ''}</span>{item.name}</td>
                    <td>{item.dept_name}</td>
                    <td>{item.sub_dept_name}</td>
                    <td>{item.user_type == 1 ? "payroll" : 'Contract'}</td>
                    <td>{item.status  === 1 ? "Active" : 'Inactive'}</td>
                    <td>
                      {/* {
                        hr_permission_arr?.includes('28') && (<button className="btn_5 mr03">View</button>)
                      } */}
                      {
                        hr_permission_arr?.includes('27') && (<Link to={`/editemployee?id=${+item.id}`} className="btn_7">Edit</Link>)
                      }
                      {/* {
                        item.official_email_status==0 && item.email_verify==1?<button className="btn_5 mr03" >Sent</button>:item.official_email_status==1 && item.email_verify==1?<button className="btn_5 mr03" >Created</button>:<button className="btn_5 mr03" onClick={() => itModal(item.id)}>Send</button>
                      } */}

                    </td>
                  </tr>
                })}
                {emplist.length < 1 && <tr className="error_mgs"><td colSpan={7}><center>No Record Found</center></td></tr>}
              </tbody>
            }
              {emplist.length > 1 && <tfoot>
                <tr><td colSpan="8" >
                  <span onClick={e => pagination.current.setState({ selected: 10 - 1 })} ></span>
                  <ReactPaginate
                    ref={pagination}
                    pageCount={Math.ceil(totalitem / perPage)}
                    pageRangeDisplayed={4}
                    marginPagesDisplayed={1}
                    onPageChange={setPage}
                    containerClassName="pagination"
                    activeClassName="active"
                    pageLinkClassName="page-link"
                    breakLinkClassName="page-link"
                    nextLinkClassName="page-link"
                    previousLinkClassName="page-link"
                    pageClassName="page-item"
                    breakClassName="page-item"
                    nextClassName="page-item"
                    previousClassName="page-item"
                    previousLabel={<>&laquo;</>}
                    nextLabel={<>&raquo;</>}
                  />
                </td></tr>
              </tfoot>}
            </table>
          </div>
        </div>
      </div>
    </>
  )
}

export default EmployeeListCom
